import { useEffect, useState } from 'react';

interface Props {
  initialNumber: number | (() => number);
  interval: number;
  limit: number;
}

export const useRotatingNumber = (props: Props): number => {
  const [currentNumber, setCurrentNumber] = useState(props.initialNumber);

  useEffect(() => {
    const interval = window.setInterval(() => {
      setCurrentNumber((index) => (index + 1) % props.limit);
    }, props.interval);

    return () => {
      window.clearInterval(interval);
    };
  }, [props.limit, props.interval]);

  return currentNumber;
};
